import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';
import { getBoardDetailViewMode } from '@atlassian/jira-software-board-common/src';
import { BOARD_DETAIL_VIEW_MODE } from '@atlassian/jira-software-board-common/src/constants';
import { VIEW_MODE_STORAGE_KEY, localStorage } from './constants';
import { VIEW_MODE_DEFAULT, type ViewModeType } from './types';

export const getViewModeFromLocalStorage = (): ViewModeType => {
	const viewModeValue = localStorage.get(VIEW_MODE_STORAGE_KEY);
	if (viewModeValue) {
		return viewModeValue;
	}
	const boardViewModeValue = getBoardDetailViewMode();
	// if there is no viewModeValue but there is a boardViewModeValue then set that value in localStorage
	// and remove the old board local storage value
	if (boardViewModeValue) {
		const boardLocalStorage = createLocalStorageProvider('software');
		localStorage.set(VIEW_MODE_STORAGE_KEY, boardViewModeValue);
		boardLocalStorage.remove(BOARD_DETAIL_VIEW_MODE);
		return boardViewModeValue;
	}
	return VIEW_MODE_DEFAULT;
	// note: during 'refactor-bento-view-mode-logic' ff cleanup (https://jbusiness.atlassian.net/browse/CAL-12), remove the above logic including getBoardDetailViewMode and uncomment
	// return localStorage.get(VIEW_MODE_STORAGE_KEY) || VIEW_MODE_DEFAULT;
};
